import React from 'react'
import PAGE_TITLES from '../../consts/titles'
import CustomHeader from '../../components/CustomHeader'
import PageHeader from '../../components/PageHeader'
import InstitutionalSettingsFeature from '../../features/InstitutionalSettings'

const InstitutionalSettingsPage: React.FC = (): JSX.Element => {
  return (
    <>
      <CustomHeader title={PAGE_TITLES.INSTITUTION_SETTINGS} />
      <PageHeader title={PAGE_TITLES.INSTITUTION_SETTINGS} isCollapsible={false} />
      <InstitutionalSettingsFeature />
    </>
  )
}

export default InstitutionalSettingsPage
